import { effect, computed } from "@preact/signals"
import { createLogger } from "./logger"
import { Auth } from "@/features_signal/auth"

const logger = createLogger("cached")

interface TokenState {
    accessToken: string
}

// 創建 signal2025
const tokenSignal = computed(() => {
    return {
        accessToken: Auth.accessTokenSignal.value,
    }
})

// 導出的方法集合

// 為了保持與之前代碼的兼容性，提供一個快速訪問方法
export const getToken = () => tokenSignal.value

// 如果需要在非組件環境中使用
export const tokenStore = {
    get: () => tokenSignal.value,
    set: (value: TokenState) => {
        Auth.setAccessToken(value.accessToken)
    },
    clear: () => {
        Auth.clearAccessToken()
    },
    subscribe: (callback: (value: TokenState) => void) => {
        effect(() => {
            callback({
                accessToken: Auth.accessTokenSignal.value ?? "",
            })
        })
    },
}
